module.exports = "/v2/pages/dashboard/dist/89a6ab117a83642df8d4c9a12787c4c2.svg";